import React from 'react';

import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

interface Props {
  open: boolean;
  catalogName?: string;
  isSubmitting: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export default function UnlockDialog({ open, catalogName, isSubmitting, onClose, onConfirm }: Props) {
  return (
    <Dialog open={open} onClose={isSubmitting ? undefined : onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Unlock {catalogName || 'catalog'}?</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Unlocking allows admins to edit this catalog again. If these values are being used in a live canvas, changes
          may affect active customer messaging.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isSubmitting}>
          Cancel
        </Button>
        <Button onClick={onConfirm} disabled={isSubmitting} variant="contained" color="warning">
          Unlock
        </Button>
      </DialogActions>
    </Dialog>
  );
}
